import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'
import { Answer, AssignmentType } from '../Types'

export type AssignmentData = Omit<AssignmentType, 'answers'> & { answers: Answer[] }
export type AssignmentDataStartEnd = { assignment: AssignmentData; startId: string | null; endId: string | null }

export const useAssignments = (projectId: string, assignmentId: string, subjectId: string) => {
  const p = ENDPOINTS.ASSIGNMENT.getAssignmentForSubject(projectId, assignmentId, subjectId)
  const { data, error, mutate } = useSWR(p, getReq, { suspense: true })

  const assignmentData: AssignmentDataStartEnd | AssignmentData | undefined = data?.data

  return {
    data: !data ? data : assignmentData,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
